import React from 'react'

import { Element } from './index.styled'

const Button = ({ children, ...props }) => {
  return (
    <Element {...props}>
      <span className='text'>{children}</span>
      <span className='arrow' />
    </Element>
  )
}

export default Button
